import React, { useEffect, useState } from 'react';
import { useModal } from '../backend/ModalContext';
import { loadScriptsSequentially } from '../utils';
import './LandingPage2.css';

function Influencer() {
    const [faqCategories, setFaqCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState(null);
    const { openModal } = useModal();

    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" + Date.now();
        script.onload = () => {
            loadScriptsSequentially([
                "js/pre-loader.js",
                "assets/bootstrap/js/popper.min.js",
                "assets/bootstrap/js/bootstrap.min.js",
                "js/parallaxie.js",
                "js/TweenMax.min.js",
                "js/jquery.wavify.js",
                "assets/wow/wow.min.js",
                "assets/counterup/jquery.counterup.min.js",
                "assets/counterup/jquery.waypoints.min.js",
                "js/main.js",
            ]);
        };
        document.body.appendChild(script);

        fetch('https://psicopatici.com/api/v1/faqs/categories')
            .then(response => response.json())
            .then(data => {
                setFaqCategories(data.data);
                setLoading(false);
                setActiveCategory(6);
            })
            .catch(error => {
                console.error('Error fetching FAQs:', error);
                setLoading(false);
            });

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <>
            {/* HERO SECTION */}
            <section style={{ marginTop: "100px" }}>
                <div className="container">
                    <div className="section_title text-center">
                        <h1 style={{ fontWeight: "600" }} className="fw-bolder">
                            HAI TANTI FOLLOWERS?
                        </h1>
                        <h4>
                            Fai conoscere i prodotti Psicopatici Italia; su ogni vendita finalizzata tramite il tuo URL di appartenenza riceverai una commissione
                        </h4>
                    </div>
                </div>
            </section>

            {/* PIANO DI GUADAGNO */}
            <section className="how-it-works">
                <div className="container">
                    <h2>Come iniziare a guadagnare come Partner Influencer?</h2>
                    <div className="cards-container">
                        {[
                            {
                                title: "Inizia a promuoverti",
                                desc: "Registrati, ricevi il tuo link/codice e inizia a pubblicare contenuti"
                            },
                            {
                                title: "Guadagna su ogni acquisto",
                                desc: "Fino al 24% di commissioni su ogni vendita"
                            },
                            {
                                title: "Ottieni bonus extra",
                                desc: "0,50 € per ogni registrazione cliente tramite il tuo link"
                            }
                        ].map((item, i) => (
                            <div key={i} className="card1" style={{ display: "flex", flexDirection: "column" }}>
                                <p><strong>{item.title}</strong></p>
                                <p style={{ color: "gray", fontSize: "12px" }}>{item.desc}</p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-4">
                        <h5>💰 Dettaglio Commissioni:</h5>
                        <div className="cards-container">
                            {[
                                { range: "0–50 acquisti", value: "15%" },
                                { range: "51–300 acquisti", value: "18%" },
                                { range: "301–1000 acquisti", value: "21%" },
                                { range: "Oltre 1000 acquisti", value: "24%" }
                            ].map((item, i) => (
                                <div key={i} className="card1" style={{ display: "flex", flexDirection: "column" }}>
                                    <p><strong>{item.range}</strong></p>
                                    <p style={{ color: "gray", fontSize: "14px" }}>{item.value} di commissione</p>
                                </div>
                            ))}
                        </div>
                        <p className="mt-3" style={{ fontSize: "14px" }}>
                            📌 Guadagni automatici per 12 mesi su ogni cliente acquisito, anche senza ulteriori clic.
                        </p>
                    </div>
                </div>
            </section>

            {/* VANTAGGI DEL RUOLO */}
            <section className="how-it-works">
                <div className="container">
                    <h2>Perché diventare Partner Influencer?</h2>
                    <div className="cards-container">
                        {[
                            "✅ Nessun investimento iniziale",
                            "🔗 Link o codice affiliato personale",
                            "🎭 Possibilità di usare volto reale o avatar",
                            "🧠 Supporto creativo e materiali promozionali",
                            "📈 Provvigioni in crescita con i risultati",
                            "📦 Accesso anticipato ai nuovi prodotti (prossimamente)"
                        ].map((text, i) => (
                            <div key={i} className="card1">
                                <p>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* BENEFICI ESCLUSIVI */}
            <section className="how-it-works">
                <div className="container">
                    <h2>I benefici riservati ai nostri partner</h2>
                    <div className="cards-container">
                        {[
                            "🎟️ Inviti a eventi e iniziative riservate",
                            "📊 Dashboard e report avanzati in tempo reale",
                            "📚 Accesso completo alla Libreria Virtuale",
                            "🏆 Possibilità di diventare ambassador ufficiale"
                        ].map((text, i) => (
                            <div key={i} className="card1">
                                <p>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* REQUISITI */}
            <section className="how-it-works">
                <div className="container">
                    <h2>Chi può diventare Partner Influencer?</h2>
                    <div className="cards-container">
                        <div className="card1">
                            <p>✔️ Presenza social attiva e in linea con il brand</p>
                        </div>
                        <div className="card1">
                            <p>✔️ Micro-influencer con contenuti autentici e costanti</p>
                        </div>
                        <div className="card1">
                            <p>✔️ Creatori digitali con forte senso dello stile</p>
                        </div>
                        <div className="card1">
                            <p>✔️ Appassionati di moda, cultura urbana o streetwear</p>
                        </div>
                        <div className="card1">
                            <p>✔️ Persone carismatiche che amano condividere la propria visione del mondo</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FORM CONTATTO */}
            <section style={{ paddingLeft: "10%", paddingRight: "10%" }} className='container mb-5 mt-5'>
                <link href="https://campaign.huberway.com/core/css/embedded.css" rel="stylesheet" type="text/css" />
                <link href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined" rel="stylesheet" />
                <div className="subscribe-embedded-form">
                    <h2 className="mt-0 text-center h_title wow fadeInUp">Richiedi Informazioni</h2>
                    <form action="https://campaign.huberway.com/lists/67b477cf9ea4d/embedded-form-subscribe-captcha" method="POST" className="form-validate-jqueryz" noValidate>
                        <div className="form-group control-text">
                            <label> Nome e Cognome <span className="text-danger">*</span></label>
                            <input id="NAME" type="text" name="NAME" className="form-control required" />
                        </div>
                        <div className="form-group control-text">
                            <label> Email <span className="text-danger">*</span></label>
                            <input id="EMAIL" type="text" name="EMAIL" className="form-control required email:rfc,filter" />
                        </div>
                        <div className="form-group control-text">
                            <label> Username Social <span className="text-danger">*</span></label>
                            <input id="SOCIAL" type="text" name="SOCIAL" className="form-control required" />
                        </div>
                        <div className="form-group control-text">
                            <label> Recapito Telefonico</label>
                            <input id="PHONE" type="text" name="PHONE" className="form-control" />
                        </div>
                        <div className="form-button text-center">
                            <button className="action_btn">Invia</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}

export default Influencer;
